// import node module libraries
import { Fragment, useEffect, useState } from 'react';
import { Accordion, Col, Row, Breadcrumb, Card, Form, Button, Spinner, Table } from 'react-bootstrap';
import { Trash, Plus, Clipboard } from 'react-feather';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

// Import authentication components
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';
import useAuthUser from 'react-auth-kit/hooks/useAuthUser';

// import notification component
import Notification, { handleShowNotification } from 'components/elements/notification/Notification';

// Import required custom components
import DotBadge from 'components/elements/bootstrap/DotBadge';

const ConnectorMSSQLSettings = ({ activeKey }) => { // activeKey als Prop erhalten
	const { t } = useTranslation(); // useTranslation-Hook
	const [notification, setNotification] = useState({ variant: '', title: '', message: '' });
	const [isLoading, setIsLoading] = useState(true); // State for loading table
	const [isLoadingButton, setIsLoadingButton] = useState(false); // State for loading spinner
	const [isButtonDisabled, setIsButtonDisabled] = useState(false); // State for button disabled when loading
	const [customNotes, setCustomNotes] = useState([{ custom_note: '', custom_merchant_sku: '' }]);

	const auth = useAuthUser(); // Assuming this gets the auth user data
	const [formData, setFormData] = useState(null);
	const [data, setData] = useState(null); // Add data state

	useEffect(() => {
		// Check if the current tab is active before making the API call
		if (activeKey === 'connector.ms-sql') {
			//getSFTPStatus(); <-- anpassen
		}
		setIsLoading(false); //temp
	}, [activeKey]); // Run effect when activeKey changes

	// API-Call Options
	const authHeader = useAuthHeader();
	const options = {
		params: {

		},
		headers: {
			Authorization: authHeader,
			Accept: 'application/json'
		}
	};

	const copyToClipboard = () => {
		navigator.clipboard.writeText('@custom_notes');
		handleShowNotification(setNotification, 'success', 'Kopiert', 'Der Text wurde in die Zwischenablage kopiert!');
	};

	// 
	// Components
	//

	// Component Status-Badge
	const statusBadge = (value) => {
		return (
			<Fragment>
				<DotBadge
					bg={
						value.includes('warning')
							? 'warning'
							: value === 'running'
								? 'success'
								: value === 'new'
									? 'info'
									: value.includes('error')
										? 'danger'
										: 'info'
					}
				></DotBadge>
				{
					value.includes('warning')
						? t('Warning')
						: value === 'running'
							? t('Running')
							: value === 'new'
								? t('New')
								: value.includes('error')
									? t('Error')
									: t('Unkown Status')
				}
			</Fragment>
		);
	}

	return (
		<Fragment>
			{notification.show && (
				<Notification variant={notification.variant} title={notification.title} message={notification.message} show={notification.show} setNotification={setNotification} />
			)}
			<Row>
				<Col xl={{ offset: 1, span: 10 }} lg={{ offset: 1, span: 10 }} md={12}>
					<Card className="mb-4">
						<Card.Header className="d-flex align-items-center justify-content-between">
							<h4 className="mb-0">{t('Installation & Deployment')}</h4>
						</Card.Header>
						<Card.Body>
							{isLoading ? (
								<div className="d-flex justify-content-center">
									<Spinner animation="border" role="status">
										<span className="visually-hidden">Loading...</span>
									</Spinner>
								</div>
							) : (
								<Form>
									<Row className="">
										<Col lg={12} md={12} className="mt-1">
											<h3 className="mb-3 border-bottom pb-2">{t('Explanation')}</h3>
											<p>{t('The connector.ms-sql will be deployed on your Docker Envirement with network accessbility to your Microsoft SQL-Server.')}</p>
										</Col>
										<Col lg={12} md={12} className="mt-3">
											<h3 className="mb-3 border-bottom pb-2">{t('Prerequisites')}</h3>
											<ul
												style={{
													listStyleType: 'circle',
													paddingLeft: '20px'
												}}
											>
												<li>{t('Docker installed')}</li>
												<li>{t('Microsoft SQL-Server accessible with Username and Password')}</li>
											</ul>
										</Col>
										<Col lg={12} md={12} className="mt-3">
											<h3 className="mb-3 border-bottom pb-2">{t('Installation & Deployment')}</h3>
											<Accordion defaultActiveKey="0" flush>
												<Accordion.Item eventKey="0">
													<Accordion.Header>{t('Container Instance running on Docker')}</Accordion.Header>
													<Accordion.Body>
														<p>1. Create API Credentials</p>
														<p>2. Enter SQL Login Data</p>
														<p>3. Create Container Instance</p>
														<p>4. Deploy Container Instance</p>
														<p>{t('To install the connector.ms-sql, you need to run the following command in your terminal:')}</p>

													</Accordion.Body>
												</Accordion.Item>
											</Accordion>
										</Col>
										<Col lg={12} md={12} className="mt-1">
											<h3 className="mb-3 border-bottom pb-2">{t('Status & Monitoring')}</h3>
											<p>{t('')}</p>
											<Table hover size="sm">
												<thead>
													<tr>
														<th>{t('Status')}</th>
														<th>{t('Container Instance ID')}</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>{statusBadge('waiting')}</td>
														<td>connector.ms-sql</td>
													</tr>
												</tbody>
											</Table>
										</Col>
									</Row>
								</Form>
							)}
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</Fragment>
	);
};

export default ConnectorMSSQLSettings;
